export default "__VITE_ASSET__pEUB9QuW__"